/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extension_Tracker_Type_Lowestprice1Inputs */

const he_extension_tracker_type_lowestprice1 = /** @type {(inputs: Extension_Tracker_Type_Lowestprice1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הכי זול אי פעם`)
};

const en_extension_tracker_type_lowestprice1 = /** @type {(inputs: Extension_Tracker_Type_Lowestprice1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lowest ever`)
};

/**
* | output |
* | --- |
* | "Lowest ever" |
*
* @param {Extension_Tracker_Type_Lowestprice1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const extension_tracker_type_lowestprice1 = /** @type {((inputs?: Extension_Tracker_Type_Lowestprice1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extension_Tracker_Type_Lowestprice1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_extension_tracker_type_lowestprice1(inputs)
	return en_extension_tracker_type_lowestprice1(inputs)
});
export { extension_tracker_type_lowestprice1 as "extension_tracker_type_lowestPrice" }